import React from "react";
import { cn } from "@/lib/utils";
import { LOGO } from "@/assets";

// On-brand full-screen loading state used for page/auth transitions.
// Pulses the real OpticSwap logo (same asset as the navbar, beta gate and /join)
// instead of a generic spinner icon.
export function LogoLoader({ className, label, testId = "logo-loader" }) {
  return (
    <div
      className={cn("min-h-screen flex flex-col items-center justify-center gap-5 bg-obsidian", className)}
      data-testid={testId}
    >
      <img
        src={LOGO}
        alt="OpticSwap"
        className="w-40 h-auto animate-pulse"
        style={{ animationDuration: "1.4s" }}
      />
      {label && (
        <p className="font-mono text-sm uppercase tracking-widest text-secondary-foreground">{label}</p>
      )}
    </div>
  );
}
